"use client";

import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react'; 
import { useCart } from '@/app/contexts/cartContext';

const ScrollTopButton = () => {
  // State to track whether the button should be visible
  const [isVisible, setIsVisible] = useState(false);
  const { isCartOpen } = useCart();

  // Effect to add and remove the scroll event listener
  useEffect(() => {
    // Function to check scroll position and toggle visibility
    const toggleVisibility = () => {
      // Show button if page is scrolled more than 100px
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener('scroll', toggleVisibility);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []); // The empty array ensures this effect runs only once

  // Function to scroll the window to the top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scrolling animated
    });
  };

  return (
    isVisible && !isCartOpen && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 z-50 hidden h-10 w-10 items-center justify-center rounded-lg bg-indigo-600 text-white shadow-lg transition-opacity duration-300 hover:bg-indigo-700 focus:outline-none md:flex"
        aria-label="Scroll to top"
      >
        <ChevronUp className="h-6 w-6" />
      </button>
    )
  );
};

export default ScrollTopButton;